import { NgModule } from '@angular/core';
import { S129gS129m01Component } from './s129g-s129m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S129gS129m01Component]
})
export class S129gModule { }

